import { Home, Dice5, Target, Settings, HelpCircle } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';

/**
 * Side navigation rail for landscape mode.
 * Displays icons only in a vertical layout.
 */
export function SideNav() {
  return (
    <nav className="relative flex flex-col items-center justify-center border-r border-primary/30 bg-gradient-to-r from-secondary to-background py-2 px-1 pl-[max(0.25rem,env(safe-area-inset-left))]">
      {/* Decorative right glow line */}
      <div className="absolute right-0 top-4 bottom-4 w-px bg-gradient-to-b from-transparent via-primary/50 to-transparent" />
      <SideNavItem to="/" icon={Home} label="Home" />
      <SideNavItem to="/roll" icon={Dice5} label="Roll" />
      <SideNavItem to="/practice" icon={Target} label="Practice" />
      <SideNavItem to="/settings" icon={Settings} label="Settings" />
      <SideNavItem to="/about" icon={HelpCircle} label="Help" />
    </nav>
  );
}

interface SideNavItemProps {
  to: string;
  icon: React.ElementType;
  label: string;
}

/**
 * Side navigation item with glow effect on active state.
 * Icon only with title tooltip.
 */
function SideNavItem({ to, icon: Icon, label }: SideNavItemProps) {
  return (
    <NavLink
      to={to}
      title={label}
      className={({ isActive }) =>
        cn(
          'flex items-center justify-center rounded-lg p-2.5 my-0.5 transition-all duration-200',
          isActive
            ? 'text-primary drop-shadow-[0_0_8px_hsl(var(--glow)/0.5)] bg-primary/10'
            : 'text-muted-foreground hover:text-foreground hover:drop-shadow-[0_0_4px_hsl(var(--glow)/0.25)] hover:bg-primary/5'
        )
      }
    >
      <Icon className="h-5 w-5" />
    </NavLink>
  );
}
